import styled, { css } from 'styled-components';
import { regularWhite, fontWeightBold } from '../design-tokens';
import { device } from '../breakpoints';
import { playFontSize } from './helpers';

export const BaseHeader = css`
    color: ${regularWhite};
    margin-bottom: 0.1em;
    font-weight: ${fontWeightBold};
`;

export const Heading1Typography = css`
    ${BaseHeader}
    ${playFontSize(3.2)}
    line-height: 1.2;

    @media ${device.GteLarge} {
        ${playFontSize(4)}
    }

    @media ${device.FullScreen} {
        ${playFontSize(5)}
    }
`;

export const Heading1 = styled.h1`
    ${Heading1Typography};
`;

export const Heading2Typography = css`
    ${BaseHeader}
    ${playFontSize(2.1)}
    line-height: 1.2;

    @media ${device.GteSmall} {
        ${playFontSize(2.6)}
    }

    @media ${device.GteLarge} {
        ${playFontSize(3.4)}
    }
`;

export const Heading2 = styled.h2`
    ${Heading2Typography}
`;

export const Heading3Typography = css`
    ${BaseHeader}
    ${playFontSize(2)}
    line-height: 1.2;

    @media ${device.GteSmall} {
        ${playFontSize(2.4)}
    }

    @media ${device.GteLarge} {
        ${playFontSize(2.6)}
    }
`;

export const Heading3 = styled.h3`
    ${Heading3Typography}
`;

export const Heading4Typography = css`
    ${BaseHeader}
    ${playFontSize(1.9)}
    line-height: 1.2;

    @media ${device.GteSmall} {
        ${playFontSize(2.2)}
    }

    @media ${device.GteLarge} {
        ${playFontSize(2.6)}
    }
`;

export const Heading4 = styled.h4`
    ${Heading4Typography}
`;

export const Heading5Typography = css`
    ${BaseHeader}
    ${playFontSize(1.8)}
    line-height: 1.2;

    @media ${device.GteSmall} {
        ${playFontSize(2)}
    }

    @media ${device.GteLarge} {
        ${playFontSize(2.2)}
    }

    @media ${device.FullScreen} {
        ${playFontSize(2.6)}
    }
`;

export const Heading5 = styled.h5`
    ${Heading5Typography}
`;
